import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = { class: "logo-section flex items-center justify-center h-16" }
const _hoisted_3 = { class: "flex items-center justify-center px-2 w-full transition-all duration-300" }
const _hoisted_4 = {
  key: 0,
  class: "hidden lg:flex items-center justify-center"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex-1 px-2 py-4 space-y-1 overflow-y-auto" }
const _hoisted_9 = {
  key: 0,
  class: "absolute left-0 top-0 bottom-0 w-1.5 bg-[#ffd62e] rounded-r-full shadow-xs"
}
const _hoisted_10 = {
  key: 0,
  class: "p-4 border-t border-gray-100 dark:border-gray-700/80 transition-all duration-300 bg-gray-50/60 dark:bg-gray-800/60"
}
const _hoisted_11 = { class: "text-center text-[11px] text-gray-500 dark:text-gray-400 space-y-1" }
const _hoisted_12 = { class: "flex items-center justify-center space-x-1.5 text-[10px] text-gray-400" }

import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import logoImage from '@/assets/company-logo.png'
import collapsedLogoImage from '@/assets/collapsed-logo.png'
import { getNavigationItems } from '@/router'
import { useUser } from '@/composables/auth/useUser'
import { useThemeStore } from '@/stores/theme'

// Props & Emits

export default /*@__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    isOpen: { type: Boolean },
    isCollapsed: { type: Boolean }
  },
  emits: ["update:isOpen", "update:isCollapsed"],
  setup(__props: any, { emit: __emit }) {

// Imports
const props = __props

const emit = __emit

// Composables
const route = useRoute()
const router = useRouter()
const { userType, isOwner } = useUser()
const themeStore = useThemeStore()
const isDarkMode = computed(() => themeStore.isDarkMode)

// Computed Properties
const navigation = computed(() => getNavigationItems([...router.options.routes], userType.value, isOwner.value))

// Methods
const isActive = (path: string) => route.path === path
const toggleSidebar = () => emit('update:isOpen', !props.isOpen)

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", {
      class: _normalizeClass(["fixed inset-y-0 left-0 z-50 bg-white dark:bg-gray-800 shadow-xl transform transition-all duration-300 ease-in-out lg:translate-x-0", [
      { '-translate-x-full': !_ctx.isOpen, 'translate-x-0': _ctx.isOpen },
      { 'w-64': !_ctx.isCollapsed, 'w-64 lg:w-20': _ctx.isCollapsed }
    ]])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.isCollapsed)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: _unref(collapsedLogoImage),
                    alt: "Company Logo",
                    class: "h-[3.5rem] w-auto",
                    style: _normalizeStyle(isDarkMode.value ? 'filter: drop-shadow(0 0 .5px #fff) drop-shadow(0 0 .5px #fff) drop-shadow(0 0 .5px #fff) drop-shadow(0 0 .5px #fff);' : '')
                  }, null, 12, _hoisted_5)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("img", {
                    src: _unref(logoImage),
                    alt: "Company Logo",
                    class: "h-[4rem] w-auto",
                    style: _normalizeStyle(isDarkMode.value ? 'filter: drop-shadow(0 0 .5px #fff) drop-shadow(0 0 .5px #fff) drop-shadow(0 0 .5px #fff) drop-shadow(0 0 .5px #fff);' : '')
                  }, null, 12, _hoisted_7),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-[2rem] font-extrabold tracking-tight text-primary dark:text-primary-dark-text" }, null, -1))
                ]))
          ])
        ]),
        _createElementVNode("nav", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.to,
              to: item.to,
              class: _normalizeClass(["group flex items-center py-2.5 rounded-xl transition-all duration-200 relative overflow-hidden", [
            {
              'bg-[#0b6623]/10 dark:bg-emerald-950/40 text-[#0b6623] dark:text-emerald-300 font-bold':
                isActive(item.to),
              'text-gray-700 dark:text-gray-200 hover:bg-[#eefaf2] hover:text-[#0b6623] dark:hover:bg-gray-700/50': !isActive(item.to),
              'lg-tooltip': _ctx.isCollapsed
            },
            _ctx.isCollapsed ? 'px-2 lg:justify-center' : 'px-3',
            _ctx.isCollapsed ? 'justify-start lg:justify-center' : 'justify-start'
          ]]),
              title: _ctx.isCollapsed ? item.name : ''
            }, {
              default: _withCtx(() => [
                (isActive(item.to))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center transition-all duration-200 relative z-10", {
              'lg:justify-center space-x-3 lg:space-x-0': _ctx.isCollapsed,
              'space-x-3': !_ctx.isCollapsed
            }])
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex items-center justify-center rounded-lg transition-all duration-200", [
                {
                  'bg-[#0b6623]/15 text-[#0b6623] dark:bg-emerald-900/50 dark:text-emerald-300': isActive(item.to),
                  'bg-gray-100 dark:bg-gray-700/50 text-gray-500 dark:text-gray-400 group-hover:bg-[#0b6623]/10 group-hover:text-[#0b6623] dark:group-hover:text-emerald-300': !isActive(item.to)
                },
                _ctx.isCollapsed ? 'w-10 h-10' : 'w-8 h-8'
              ]])
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                      class: _normalizeClass([
                  'w-5 h-5 flex-shrink-0 transition-all duration-200 group-hover:scale-110',
                  isActive(item.to)
                    ? 'text-[#0b6623] dark:text-emerald-300'
                    : 'text-gray-500 dark:text-gray-400 group-hover:text-[#0b6623] dark:group-hover:text-emerald-300'
                ])
                    }, null, 8, ["class"]))
                  ], 2),
                  _createElementVNode("span", {
                    class: _normalizeClass(["text-sm font-bold truncate transition-all duration-200", {
                'lg:hidden': _ctx.isCollapsed,
                block: !_ctx.isCollapsed
              }])
                  }, _toDisplayString(item.name), 3)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["absolute inset-0 opacity-0 group-hover:opacity-100 bg-[#0b6623]/5 dark:bg-emerald-400/5 transition-all duration-300", { 'opacity-0': isActive(item.to) }])
                }, null, 2)
              ]),
              _: 2
            }, 1032, ["to", "class", "title"]))
          }), 128))
        ]),
        (!_ctx.isCollapsed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "font-bold text-[#0b6623] dark:text-emerald-400" }, "Jeducare Services, Inc.", -1)),
                _createElementVNode("div", _hoisted_12, [
                  _cache[1] || (_cache[1] = _createElementVNode("span", null, "Bowie • Clinton", -1)),
                  _cache[2] || (_cache[2] = _createElementVNode("span", null, "•", -1)),
                  _createElementVNode("span", null, "© " + _toDisplayString(new Date().getFullYear()), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 z-40 bg-black/50 backdrop-blur-sm lg:hidden transition-opacity duration-300",
          onClick: toggleSidebar
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})